import { SelectOption } from "../common/general";

export const processOptions: SelectOption[] = [
    {value: '0', item: '承認'},
    {value: '1', item: '決裁'},
    {value: '2', item: '確認'}
];